import { render, staticRenderFns } from "./ShareOfShelfKeywordModal.vue?vue&type=template&id=8a148f8e&scoped=true"
import script from "./ShareOfShelfKeywordModal.vue?vue&type=script&lang=js"
export * from "./ShareOfShelfKeywordModal.vue?vue&type=script&lang=js"
import style0 from "./ShareOfShelfKeywordModal.vue?vue&type=style&index=0&id=8a148f8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a148f8e",
  null
  
)

export default component.exports